import React from 'react';
import { dispatch } from '@rematch/core';
const plansColors = ['alpha', 'charlie', 'bravo', 'delta'];

function PricingTable({ plans, currencyCode, periodUnit }) {

  const currencySymbol =
    currencyCode === "usd" ? "$" :
    currencyCode === "inr" ? "₹" :
    currencyCode === "eur" ? "€" :
    currencyCode === "gbp" ? "£" : "$";

  const startCheckout = async (plan) => {
    await dispatch.account.createCheckoutSession({
      planId: plan.id,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  };

  if (!plans || plans.length === 0) {
    return <h3>No Plans Available</h3>;
  }

  return (
    <div>
      <div id="pricing">
        {plans.map((plan, index) => (
          <div key={index} className={`price_card box ${plansColors[index]}`}>
            <div className="ribbon">
              <span>{periodUnit === "month" ? "Monthly" : "Yearly"}</span>
            </div>

            <div className="header">
              <span className="price">
                {currencySymbol}{plan.price}
              </span>
              <span className="name">{plan.displayName}</span>
            </div>
            <button className='pricing-button' onClick={() => startCheckout(plan)}>
              Get Started
            </button>
            <ul className="features">
              {plan.attributes.map((attr, i) => (
                <li key={i}>{attr}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PricingTable;
